import React from 'react';
import { Link } from 'react-router-dom';
const TripCard = ({
  trip
}) => {
  return <div className="rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow bg-white" data-id="element-540">
      <div className="relative h-48" data-id="element-541">
        <img src={trip.image} alt={trip.name} className="w-full h-full object-cover" data-id="element-542" />
        <div className="absolute top-4 left-4 bg-navy-900 text-white px-3 py-1 text-sm font-medium rounded" data-id="element-543">
          {trip.duration}
        </div>
      </div>
      <div className="p-6" data-id="element-544">
        <div className="text-sm text-navy-600 mb-2" data-id="element-545">{trip.cities}</div>
        <h3 className="text-xl font-bold text-navy-900 mb-2" data-id="element-546">{trip.name}</h3>
        <p className="text-navy-700 mb-4 line-clamp-2" data-id="element-547">{trip.description}</p>
        <div className="flex justify-between items-center" data-id="element-548">
          <div data-id="element-549">
            <span className="text-sm text-navy-600" data-id="element-550">FROM</span>
            <div className="text-xl font-bold text-gold-500" data-id="element-551">${trip.price}</div>
          </div>
          <Link to={`/tour/${trip.id}`} className="bg-navy-900 hover:bg-navy-800 text-white px-4 py-2 rounded text-sm font-medium transition-colors" data-id="element-552">
            View Details
          </Link>
        </div>
      </div>
    </div>;
};
export default TripCard;